import { Injectable, inject } from "@angular/core";
import {Store} from "@ngrx/store";
import {Router, UrlTree} from "@angular/router";
import {Observable, withLatestFrom} from "rxjs";
import {TeamRegisterSelectors} from "@team/pages/register/store/team-register.selector-type";
import {map} from "rxjs/operators";
import {SharedLoginSelectors} from "@shared/components/login/store/shared-login.selector-type";

@Injectable({
  providedIn: 'root'
})
export class TeamLoginPageGuard {
  private _store = inject(Store);
  private _router = inject(Router);


  canActivate():
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {

    return this._store.pipe(
      withLatestFrom(this._store.select(SharedLoginSelectors.selectToken)),
      map(([_, token]) => {
        if (!token?.info?.isGuest) {
          return true;
        } else {
          return this._router.createUrlTree(['team/welcome']);
        }
      })
    );
  }
}
